import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wrench, FileText, Trophy, MapPin, CalendarClock, Star, ArrowUpRight, Bell } from "lucide-react";
import api from "@/lib/api";

const CARDS = [
  { key: "services", label: "Hizmetler", icon: Wrench, to: "/admin/c/services" },
  { key: "blogs", label: "Blog Yazıları", icon: FileText, to: "/admin/c/blogs" },
  { key: "case_studies", label: "Uygulamalar", icon: Trophy, to: "/admin/c/case-studies" },
  { key: "districts_pages", label: "İlçe Sayfaları", icon: MapPin, to: "/admin/c/lokasyonlar" },
  { key: "reviews", label: "Yorumlar", icon: Star, to: "/admin/c/reviews" },
  { key: "appointments", label: "Toplam Randevu", icon: CalendarClock, to: "/admin/randevular" },
];

export default function Dashboard() {
  const [stats, setStats] = useState({});

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display text-2xl font-medium text-white sm:text-3xl">Gösterge Paneli</h1>
      <p className="mt-1 text-sm text-neutral-500">Meguiar's İzmit içerik ve randevu yönetimi.</p>

      {stats.new_appointments > 0 && (
        <Link to="/admin/randevular" className="mt-6 flex items-center gap-3 rounded-2xl border border-gold/30 bg-gold/10 px-5 py-4 text-sm font-medium text-gold transition-colors hover:bg-gold/15">
          <Bell className="h-5 w-5" /> {stats.new_appointments} yeni randevu talebiniz var. Görüntülemek için tıklayın.
        </Link>
      )}

      <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {CARDS.map((c) => {
          const Icon = c.icon;
          return (
            <Link key={c.key} to={c.to} data-testid={`stat-${c.key}`} className="group rounded-2xl border border-white/10 bg-white/[0.02] p-6 transition-colors hover:border-gold/30">
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-gold/10 text-gold"><Icon className="h-5 w-5" /></span>
                <ArrowUpRight className="h-5 w-5 text-neutral-600 group-hover:text-gold transition-colors" />
              </div>
              <p className="mt-5 font-display text-3xl font-semibold text-white">{stats[c.key] ?? "—"}</p>
              <p className="mt-1 text-sm text-neutral-400">{c.label}</p>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
